<template>
  <div class="pt-4">
    <!-- toggle button -->
    <b-button
      v-on:click="$emit('set-action', action)"
      v-b-modal="`modal-action-${action}`"
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      :variant="color"
      block
    >
      {{ title }}
    </b-button>
    <ModalComment
      :newFlow="newFlow"
      v-if="commentModal.includes(action)"
      :action="action"
      :title="title"
      :step-id="stepId"
    />
    <ModalEdition
      v-if="editModal.includes(action)"
      :action="action"
      :title="title"
      :step-id="stepId"
      :attachment="attachment"
    />
    <ModalResend
      v-if="resendModal.includes(action)"
      :action="action"
      :title="title"
      :step-id="stepId"
      :is-signer="isSigner"
      :has-signature-positon="hasSignaturePosition"
    />
    <ModalSign
      :newFlow="newFlow"
      v-if="signModal.includes(action)"
      :action="action"
      :title="title"
      :step-id="stepId"
      :get-sign="getSign"
      @selectedSign="$emit('selectedSign', $event)"
    />
    <ModalSignAttachment
      v-if="signAttachmentModal.includes(action)"
      :action="action"
      :title="title"
      :attachment="attachment"
      :step-id="stepId"
      :get-sign="getSign"
    />
    <ModalOffice
      v-if="officeModal.includes(action)"
      :process="process"
      :action="action"
      :title="title"
      :step-id="stepId"
      :get-sign="getSign"
    />
    <ModalManageDate
      v-if="manageDateModal.includes(action)"
      :process="process"
      :action="action"
      :title="title"
      :step-id="stepId"
      :get-sign="getSign"
    />
    <ModalConfigureSign
      v-if="configureSignModal.includes(action)"
      :process="process"
      :action="action"
      :title="title"
      :step-id="stepId"
      :get-sign="getSign"
    />
  </div>
</template>
<script>

import {
  BButton, BModal,
  VBToggle
} from 'bootstrap-vue';
import Ripple from 'vue-ripple-directive';

import ModalResend from '@/febos/chile/approvals/components/trays/managementTray/modals/ModalResend';
import ModalComment from '@/febos/chile/approvals/components/trays/managementTray/modals/ModalComment';
import ModalSign from '@/febos/chile/approvals/components/trays/managementTray/modals/ModalSign';
import ModalSignAttachment from '@/febos/chile/approvals/components/trays/managementTray/modals/ModalSignAttachment';
import ModalOffice from '@/febos/chile/approvals/components/trays/managementTray/modals/ModalOffice';
import ModalManageDate from '@/febos/chile/approvals/components/trays/managementTray/modals/ModalManageDate';
import ModalConfigureSign from '@/febos/chile/approvals/components/trays/managementTray/modals/ModalConfigureSign';
import ModalEdition from '@/febos/chile/approvals/components/trays/managementTray/modals/ModalEdition';

export default {
  components: {
    BModal,
    ModalManageDate,
    ModalConfigureSign,
    BButton,
    ModalSign,
    ModalSignAttachment,
    ModalComment,
    ModalResend,
    ModalOffice,
    ModalEdition
  },
  data() {
    return {
      commentModal: ['approve', 'reject', 'return', 'comment', 'attach'],
      editModal: ['edit'],
      resendModal: ['resend'],
      signModal: ['sign'],
      signAttachmentModal: ['sign-attachment'],
      officeModal: ['manage'],
      configureSignModal: ['configure'],
      manageDateModal: ['manage-date'],
      comment: '',
      commentFile: {},
      comentManagementFiles: []
    };
  },
  watch: {
    openManageFlowModal(newVal) {
    }
  },
  props: {
    action: { type: String, required: true },
    title: { type: String, required: true },
    color: { type: String, required: true },
    process: Boolean,
    stepId: Object,
    openManageFlowModal: { type: Boolean, default: true },
    getSign: Function,
    modal: String,
    attachment: Object,
    newFlow: Object,
    isSigner: { type: Boolean, default: false },
    hasSignaturePosition: { type: Boolean },
  },
  directives: {
    'b-toggle': VBToggle,
    Ripple,
  }
};
</script>
